import React, { useState, useEffect } from 'react';
import { map } from 'lodash/fp';
import PropTypes from 'prop-types';
import EstimateBuilder from './EstimateBuilderConnector';
import updateEstimateURL from '../helpers/updateEstimateURL';

const handleCartMessage = (fireCartMessage, fromCart) => {
  if (fromCart === 'true') {
    fireCartMessage(
      'This estimate has been saved. You can access it anytime from <a href="myaccount/estimates">My Estimates</a>.',
      5000,
    );
  }
};

const LoadEstimateLoader = ({
  loadDesign,
  cartConvertedSuccessfully,
  selectedEstimate,
  clearDesignsByMode,
  match: { params },
}) => {
  const [loaded, setLoaded] = useState(false);
  const { designIds } = params;
  const fromCart = new URLSearchParams(location.search).get('fromCart');

  const designsToLoad = designIds.split(',');

  useEffect(() => {
    const loaders = map(loadDesign)(designsToLoad);
    Promise.all(loaders)
      .then(() => {
        handleCartMessage(cartConvertedSuccessfully, fromCart);
        setLoaded(true);
      });
  }, designsToLoad);

  useEffect(() => {
    if (loaded) {
      clearDesignsByMode();
      updateEstimateURL(selectedEstimate);
    }
  }, [loaded, selectedEstimate]);

  return loaded
    ? <EstimateBuilder />
    : null;
};

LoadEstimateLoader.propTypes = {
  loadDesign: PropTypes.func.isRequired,
  clearDesignsByMode: PropTypes.func.isRequired,
  cartConvertedSuccessfully: PropTypes.func.isRequired,
  selectedEstimate: PropTypes.shape({
    designId: PropTypes.string.isRequired,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({}).isRequired,
  }).isRequired,
};
LoadEstimateLoader.defaultProps = {
  selectedEstimate: undefined,
};

export default LoadEstimateLoader;
